import { environment } from '../../../../environments/environment';
import { GeneralResponse } from './../../models/general-response/general-response';
import { GlobalService } from '../global/global.service';
import { HttpService } from './../../http/http.service';
import { IBusinessInformation } from './../../models/business-information/ibusiness-information';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { IContribuyente } from '../../models/worker/iworker-information';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  private _getBusinnessInformation$: Subject<IContribuyente>;

  constructor(
    private _global: GlobalService,
    private _http: HttpService) {
      this._getBusinnessInformation$ = new Subject<IContribuyente>();
  }

  /**
   * Consulto la informacion de la empresa
   * @param docTypeCompany Tipo documento de la empresa
   * @param docNumberCompany Numero documento de la empresa
   * @param checkDigit Digito verificacion empresa
   */
  getBusinnessInformation(docTypeCompany: string, docNumberCompany: string, checkDigit: string): Observable<GeneralResponse<IBusinessInformation>> {
    const params = {
      tipoId: docTypeCompany,
      numeroId: docNumberCompany + checkDigit
    };

    return this._http.get(
      environment.AFILIACION.VALIDADOR_EMPRESAS_API,
      '/validate-company',
      params
    );
  }

  setBusinnessInformation(companyData: IContribuyente){
    this._getBusinnessInformation$.next(companyData);
  }

  getBusinnessInformationObs(): Observable<IContribuyente> {
    return this._getBusinnessInformation$;
  }
}
